<template>
    <div>
      <div v-if="loading">Loading form...</div>
      <div v-else>
        <form>
          <div v-for="(value, key) in checkboxFields" :key="key">
            <label>
              <input type="checkbox" :name="value" v-model="checkboxStates[key]"/>
              {{ value }}
            </label>
          </div>
          <div v-for="(value, key) in emailField" :key="key">
            <label>
              <input type="checkbox" :name="value" v-model="emailState[key]"/>
              {{ value }}
            </label>
          </div>
          <button type="button" class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded" @click="apply">Apply</button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: null,
        checkboxFields: null,
        checkboxValues: null,
        checkboxStates: {},
        emailField: null,
        emailValue: null,
        emailState: {},
        loading: true,
      };
    },
  
    async mounted() {
        try {
            const response = await fetch('/api/forms/apply');
            
            this.form = await response.json();
            //console.log(this.form);
            this.checkboxFields = this.form.fields.apply_boxes.options;
            this.emailField = this.form.fields.email.options;
            //console.log(this.checkboxFields);
            //console.log(this.emailField);
            this.checkboxValues = this.checkboxFields.value;
            this.emailValue = this.emailField.value;
            //console.log(this.checkboxValues)
            //console.log(this.emailValue)
            this.loading = false;
        } catch (error) {
            console.error(error);
            this.loading = false;
        }

        Object.keys(this.checkboxFields).forEach((key) => {
            this.checkboxStates[key] = false;
        });
        Object.keys(this.emailField).forEach((key) => {
            this.emailState[key] = false;
        });
        //console.log(this.checkboxStates)
    },
    computed: {
    },
    methods: {
        async apply() {
            
            const someUnchecked = Object.values(this.checkboxStates).some(value => !value);
            //console.log(someUnchecked);
            const emailUnchecked = Object.values(this.emailState).some(value => !value);
            //console.log(emailUnchecked);

            if (someUnchecked) {
                alert('Please check at least the first three boxes before submitting.')
                return
            }

            try {
              if(emailUnchecked) {
                window.location = '/apply?email=no';
              } else {
                window.location = '/apply?email=yes';
              }
            } catch (error) {
                console.error(error);
            }
        },
    },
  };
  </script>
  